import React from 'react';
import s from './resources.module.css';

// Home, then each folder down to where the view is (`breadcrumb` in
// core/src/resources.rs). Every crumb but the last goes back up the tree.
export default function Breadcrumb({ crumbs, onOpen }) {
  return (
    <nav className={s.crumbs} aria-label="Folder">
      {crumbs.map((c, i) => {
        const last = i === crumbs.length - 1;
        return (
          <React.Fragment key={c.id || 'home'}>
            {i > 0 ? <span className={s.crumbSep} aria-hidden="true">›</span> : null}
            {last
              ? <span className={s.crumbHere} aria-current="page">{c.name}</span>
              : <button type="button" className={s.crumb} onClick={() => onOpen(c.id)}>{c.name}</button>}
          </React.Fragment>
        );
      })}
    </nav>
  );
}

// The two glyphs a row starts with. Inline for the reason Icon.jsx gives about
// single paths on the 16-pixel grid; kept here because nothing else draws them.
export function FolderGlyph() {
  return (
    <svg className={s.glyph} width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
      <path d="M1.8 4.2a1 1 0 0 1 1-1h3.3l1.5 1.6h5.6a1 1 0 0 1 1 1v6.9a1 1 0 0 1-1 1H2.8a1 1 0 0 1-1-1V4.2Z"
            stroke="currentColor" strokeWidth="1.4" strokeLinejoin="round" />
    </svg>
  );
}

export function FileGlyph() {
  return (
    <svg className={s.glyph} width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
      <path d="M4 1.8h5l3.2 3.2v8.2a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2.8a1 1 0 0 1 1-1Z M9 1.8V5h3.2"
            stroke="currentColor" strokeWidth="1.4" strokeLinejoin="round" />
    </svg>
  );
}
